import styled, { css } from 'styled-components';
import breakpoints from '../breakpoints';
import { Link as LinkRouter } from '@reach/router';

export const Container = styled.div`
  display: block;
  width: 100%;
  background: #FFF;
  ${breakpoints('tablet')} {
    padding: 0;
  }
`
export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 0 20px;
  width: 100%;
  max-width: 1440px;
  margin:  auto;
  box-sizing: border-box;
  flex-wrap: nowrap;
  ${breakpoints('tablet', 'down')}{
    padding: 0;
  }

`
export const Logo = styled(LinkRouter)`
  margin-right: auto;
  ${({ie}) => {
    if (ie === "true") {return 'margin-right: 40%;'}
  }}
  a:visited {
    color: #272f69;
  }
  ${breakpoints('tablet')} {
    width: 37%;
  }
`
export const LogoImage = styled.div`
  display:flex;
  max-width: 120px;

  ${breakpoints('tablet', 'up')} {
    max-width: 260px;
  }
  ${breakpoints('tablet', 'down')} {
    & img {
      padding-left: 5px;
    }
  }
  padding: ${({ isMobile }) => isMobile && '7px'};
  
  
`
export const NavItem = styled.div`
`
export const Link = styled(LinkRouter)`
  color: #000;
  text-decoration: none;
  width: 230px;
  margin-right: 20px;
  &:hover {
    color: #cc0000;
    text-decoration: underline;
  }
`
export const Section = styled.div`
  display: flex;
  align-items: center;
  height: inherit;
`

export const LanguageSection = styled.div`
  background-color: #f1f1f1;
  display: flex;
  justify-content: flex-end;
  text-align: center;
  align-items: center;
  padding: 4px 0;
  margin: 0;
`

export const LanguageButton = styled.button`
  margin: 0 15px;
  border: none;
  background: none;
  font-family: 'ToyotaType Semibold';
  font-weight: bold;
  line-height: 1.30;
  font-size: 14px;
  &.active {
    font-family: 'ToyotaType Bold';
  }
  &:hover {
    color: #cc0000;
    text-decoration: underline;
    cursor: pointer;
  }
`
export const Separator = styled.span`
  font-size: 21px;
`
export const About = styled.div`
`